import React from 'react';
import { sendChatComposerNextechLead } from '../../../../redux/leadModalActions.js';
import GenericLeadSyncComposer from '../GenericLeadSyncComposer.js';

const NextechAddPatientComposer = () => {
  return <GenericLeadSyncComposer id={'nextech'} title={'Nextech'} syncMethod={sendChatComposerNextechLead} />;
};

export default NextechAddPatientComposer;
